import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSessionPermission } from '@btime/react-session'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../components/form/CheckboxInput'

const ReviewSection = () => {
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()
  const { t } = useTranslation('editChecklist')
  const canHandleReview = useSessionPermission('reviewServiceOrder')

  const commonProps = { handleChange, form, t }

  if (!canHandleReview) return null

  return (
    <CheckboxInput
      label={t('fieldsStep.allowReview')}
      value={form.allowReview}
      onChange={value => handleChange('allowReview', value)}
      {...commonProps}
    />
  )
}

export default ReviewSection
